import React from 'react';
import {Button, ModalFooter} from "reactstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSave, faTimes} from "@fortawesome/free-solid-svg-icons";
import {IconDefinition} from "@fortawesome/fontawesome-common-types";
import {ModalType} from "../../Store/Modal/Types";
import {useDispatch} from "react-redux";
import {ModalActions} from "../../Store/Modal/Slice";

interface IModalFooterWithButtonProps {
  onSave?: (e: any) => void;
  onClose?: (e: any) => void;
  saveTitle?: string;
  cancelTitle?: string;
  withSaveIcon?: boolean;
  withCancelIcon?: boolean;
  saveIcon?: IconDefinition;
  cancelIcon?: IconDefinition;
  disabledSave?: boolean;
  isLoading?:boolean;
  modal?: ModalType
  defaultClose?: boolean
  asInformative?: boolean;
}

const ModalFooterWithButtons = ({
  onSave, onClose,
  saveTitle = "Guardar", cancelTitle = "Cancelar",
  withCancelIcon = true, withSaveIcon = true,
  cancelIcon = faTimes, saveIcon = faSave,
  disabledSave,
  isLoading,
  defaultClose,
  modal,
  asInformative
}: IModalFooterWithButtonProps) => {

  const dispatch = useDispatch();

  const _onClose = (e: any) => {
    if (defaultClose || asInformative) modal && dispatch(ModalActions.closeModal({ modal: modal }))
    else onClose && onClose(e);
  }

  return (
    <ModalFooter className="border-0">
      {
        !asInformative &&
        <Button
          color="secondary"
          onClick={_onClose}
        >
          { withSaveIcon && <FontAwesomeIcon icon={cancelIcon}/> } &nbsp;
          { cancelTitle }
        </Button>
      }
      <Button
        color="success"
        onClick={(e: any) => {
          if (asInformative) _onClose(e);
          else onSave && onSave(e);
        }}
        disabled={disabledSave}
      >
        { withCancelIcon && !isLoading && <FontAwesomeIcon icon={saveIcon}/> } &nbsp;
        { !isLoading && saveTitle }
        { isLoading &&
        <>
	        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"/>
	        &nbsp;Cargando...
        </>
        }
      </Button>
    </ModalFooter>
  );
};
export default ModalFooterWithButtons;
